import { createReducer } from '@reduxjs/toolkit';
import { EntityTypes } from 'constants/entities';
import { cases } from './cases';

export interface IStateReducer {
  [EntityTypes.COURSE_PROGRESS]: number;
  [EntityTypes.ACTION]: number;
  [EntityTypes.ACTION_ENTITY]: number;
  [EntityTypes.ACTION_AUDIO]: number;
  [EntityTypes.ANIMATION]: number;
  [EntityTypes.AUDIO]: number;
  [EntityTypes.AUDIO_FILE]: number;
  [EntityTypes.CERTIFICATE]: number;
  [EntityTypes.GROUP_ACCESS_PERMISSION]: number;
  [EntityTypes.IMAGE]: number;
  [EntityTypes.IMAGE_FILE]: number;
  [EntityTypes.MEDIA_ASSET]: number;
  [EntityTypes.MODEL]: number;
  [EntityTypes.MODEL_ENTITY_CONFIG]: number;
  [EntityTypes.MODEL_FILE]: number;
  [EntityTypes.MODULE]: number;
  [EntityTypes.MODULE_VERSION]: number;
  [EntityTypes.NODE]: number;
  [EntityTypes.NOTIFICATION]: number;
  [EntityTypes.ORGANISATION]: number;
  [EntityTypes.ORG_CONFIG]: number;
  [EntityTypes.ORG_USER]: number;
  [EntityTypes.ORG_USER_CERTIFICATE]: number;
  [EntityTypes.ORG_USER_STATE]: number;
  [EntityTypes.ORG_USER_VARIABLE]: number;
  [EntityTypes.ORG_USER_VERIFICATION]: number;
  [EntityTypes.ORG_USER_VERIFICATION_ENTITY]: number;
  [EntityTypes.ORG_USER_VERIFICATION_ENTITY_MEDIA]: number;
  [EntityTypes.ORG_SYSTEM]: number;
  [EntityTypes.ORG_SYSTEM_VALUE]: number;
  [EntityTypes.PORTRAIT_VARIANT]: number;
  [EntityTypes.POSITION]: number;
  [EntityTypes.ROLE_CONFIG]: number;
  [EntityTypes.ROTATION]: number;
  [EntityTypes.SCENE]: number;
  [EntityTypes.SCENE_CONFIG]: number;
  [EntityTypes.SESSION_ATTEMPT]: number;
  [EntityTypes.TEXT]: number;
  [EntityTypes.TOKEN]: string;
  [EntityTypes.TAG]: number;
  [EntityTypes.TAG_JOIN]: number;
  [EntityTypes.TRANSCRIPTION]: number;
  [EntityTypes.TRANSCRIPTION_ITEM]: number;
  [EntityTypes.TRANSLATION]: number;
  [EntityTypes.VARIABLE]: number;
  [EntityTypes.VARIABLE_OPTION]: number;
  [EntityTypes.VERIFICATION_REQUEST]: number;
  [EntityTypes.VERIFICATION_REQUEST_ENTITY]: number;
  [EntityTypes.VERIFICATION_RESPONSE]: number;
  [EntityTypes.VIDEO]: number;
  [EntityTypes.VIDEO_FILE]: number;

  [EntityTypes.ACTION_TEMPLATE]: number;
  [EntityTypes.CALENDAR]: number;
  [EntityTypes.CERTIFICATE_PERMISSION]: number;
  [EntityTypes.COURSE]: number;
  [EntityTypes.COURSE_OUT]: number;
  [EntityTypes.COURSE_NODE]: number;
  [EntityTypes.COURSE_GROUP_INSTANCE]: number;
  [EntityTypes.COURSE_PERMISSION]: number;
  [EntityTypes.COURSE_VARIABLE]: number;
  [EntityTypes.DOMAIN]: number;
  [EntityTypes.EMAIL]: number;
  [EntityTypes.FOLDER]: number;
  [EntityTypes.FOLDER_PERMISSION]: number;
  [EntityTypes.FORUM_POST]: number;
  [EntityTypes.FORUM_POST_VIEW]: number;
  [EntityTypes.FORUM_TOPIC]: number;
  [EntityTypes.GROUP]: number;
  [EntityTypes.GROUP_PERMISSION]: number;
  [EntityTypes.GROUP_USER]: number;
  //[EntityTypes.LANG]: number;
  [EntityTypes.MEDIA_SYSTEM]: number;
  [EntityTypes.MODULE_OUT]: number;
  [EntityTypes.MODULE_PERMISSION]: number;
  [EntityTypes.ORG_TAG]: number;
  [EntityTypes.OVERRIDE]: number;
  [EntityTypes.SEARCH]: number;
  [EntityTypes.SEARCH_RESULT]: number;
  [EntityTypes.SERVICE]: number;
  [EntityTypes.SERVICE_ATTRIBUTE]: number;
  [EntityTypes.SESSION]: number;
  [EntityTypes.SESSION_ACTION]: number;
  [EntityTypes.SESSION_RESOURCE]: number;
  [EntityTypes.SESSION_VARIABLE]: number;
  [EntityTypes.STRUCTURE]: number;
  [EntityTypes.STRUCTURE_GROUP_INSTANCE]: number;
  [EntityTypes.STRUCTURE_OUT]: number;
  [EntityTypes.STRUCTURE_PERMISSION]: number;
  [EntityTypes.SYSTEM]: number;
  [EntityTypes.SYSTEM_USER]: number;
  [EntityTypes.SYSTEM_ATTRIBUTE]: number;
  [EntityTypes.SYSTEM_SERVICE]: number;
  [EntityTypes.TEMPLATE]: number;
  [EntityTypes.THEME]: number;
  [EntityTypes.VERIFICATION]: number;
  [EntityTypes.VIDEO_GROUP]: number;
  [EntityTypes.VIDEO_TEMPLATE]: number;
}

const initialState: IStateReducer = {
  [EntityTypes.COURSE_PROGRESS]: null,
  [EntityTypes.ACTION]: null,
  [EntityTypes.ACTION_ENTITY]: null,
  [EntityTypes.ACTION_AUDIO]: null,
  [EntityTypes.ANIMATION]: null,
  [EntityTypes.AUDIO]: null,
  [EntityTypes.AUDIO_FILE]: null,
  [EntityTypes.CERTIFICATE]: null,
  [EntityTypes.GROUP_ACCESS_PERMISSION]: null,
  [EntityTypes.IMAGE]: null,
  [EntityTypes.IMAGE_FILE]: null,
  [EntityTypes.MEDIA_ASSET]: null,
  [EntityTypes.MODEL]: null,
  [EntityTypes.MODEL_ENTITY_CONFIG]: null,
  [EntityTypes.MODEL_FILE]: null,
  [EntityTypes.MODULE]: null,
  [EntityTypes.MODULE_VERSION]: null,
  [EntityTypes.NODE]: null,
  [EntityTypes.NOTIFICATION]: null,
  [EntityTypes.ORGANISATION]: null,
  [EntityTypes.ORG_CONFIG]: null,
  [EntityTypes.ORG_USER]: null,
  [EntityTypes.ORG_USER_CERTIFICATE]: null,
  [EntityTypes.ORG_USER_STATE]: null,
  [EntityTypes.ORG_USER_VARIABLE]: null,
  [EntityTypes.ORG_USER_VERIFICATION]: null,
  [EntityTypes.ORG_USER_VERIFICATION_ENTITY]: null,
  [EntityTypes.ORG_USER_VERIFICATION_ENTITY_MEDIA]: null,
  [EntityTypes.ORG_SYSTEM]: null,
  [EntityTypes.ORG_SYSTEM_VALUE]: null,
  [EntityTypes.PORTRAIT_VARIANT]: null,
  [EntityTypes.POSITION]: null,
  [EntityTypes.ROLE_CONFIG]: null,
  [EntityTypes.ROTATION]: null,
  [EntityTypes.SCENE]: null,
  [EntityTypes.SCENE_CONFIG]: null,
  [EntityTypes.SESSION_ATTEMPT]: null,
  [EntityTypes.TAG]: null,
  [EntityTypes.TAG_JOIN]: null,
  [EntityTypes.TEXT]: null,
  [EntityTypes.TOKEN]: null,
  [EntityTypes.TRANSCRIPTION]: null,
  [EntityTypes.TRANSCRIPTION_ITEM]: null,
  [EntityTypes.TRANSLATION]: null,
  [EntityTypes.VARIABLE]: null,
  [EntityTypes.VARIABLE_OPTION]: null,
  [EntityTypes.VERIFICATION_REQUEST]: null,
  [EntityTypes.VERIFICATION_REQUEST_ENTITY]: null,
  [EntityTypes.VERIFICATION_RESPONSE]: null,
  [EntityTypes.VIDEO]: null,
  [EntityTypes.VIDEO_FILE]: null,
  [EntityTypes.ACTION_TEMPLATE]: null,
  [EntityTypes.CALENDAR]: null,
  [EntityTypes.CERTIFICATE_PERMISSION]: null,
  [EntityTypes.COURSE]: null,
  [EntityTypes.COURSE_NODE]: null,
  [EntityTypes.COURSE_OUT]: null,
  [EntityTypes.COURSE_GROUP_INSTANCE]: null,
  [EntityTypes.COURSE_PERMISSION]: null,
  [EntityTypes.COURSE_VARIABLE]: null,
  [EntityTypes.DOMAIN]: null,
  [EntityTypes.EMAIL]: null,
  [EntityTypes.FOLDER]: null,
  [EntityTypes.FOLDER_PERMISSION]: null,
  [EntityTypes.FORUM_POST]: null,
  [EntityTypes.FORUM_POST_VIEW]: null,
  [EntityTypes.FORUM_TOPIC]: null,
  [EntityTypes.GROUP]: null,
  [EntityTypes.GROUP_PERMISSION]: null,
  [EntityTypes.GROUP_USER]: null,
  //[EntityTypes.LANG]: number;
  [EntityTypes.MEDIA_SYSTEM]: null,
  [EntityTypes.MODULE_OUT]: null,
  [EntityTypes.MODULE_PERMISSION]: null,
  [EntityTypes.ORG_TAG]: null,
  [EntityTypes.OVERRIDE]: null,
  [EntityTypes.SEARCH]: null,
  [EntityTypes.SEARCH_RESULT]: null,
  [EntityTypes.SERVICE]: null,
  [EntityTypes.SERVICE_ATTRIBUTE]: null,
  [EntityTypes.SESSION]: null,
  [EntityTypes.SESSION_ACTION]: null,
  [EntityTypes.SESSION_RESOURCE]: null,
  [EntityTypes.SESSION_VARIABLE]: null,
  [EntityTypes.STRUCTURE]: null,
  [EntityTypes.STRUCTURE_GROUP_INSTANCE]: null,
  [EntityTypes.STRUCTURE_OUT]: null,
  [EntityTypes.STRUCTURE_PERMISSION]: null,
  [EntityTypes.SYSTEM]: null,
  [EntityTypes.SYSTEM_USER]: null,
  [EntityTypes.SYSTEM_ATTRIBUTE]: null,
  [EntityTypes.SYSTEM_SERVICE]: null,
  [EntityTypes.TEMPLATE]: null,
  [EntityTypes.THEME]: null,
  [EntityTypes.VERIFICATION]: null,
  [EntityTypes.VIDEO_GROUP]: null,
  [EntityTypes.VIDEO_TEMPLATE]: null,
};

export default createReducer(initialState, cases);
